import RoomAllotmentChangeLog from './RoomAllotmentChangeLog.vue';

export default RoomAllotmentChangeLog;
